import { Button } from "@/components/ui/button";
import { useSendOtpMutation } from "@/lib/services/data-layer/core";
import { formatTime } from "@/lib/helper";
import { OtpAction } from "@/pages/auth/otp/otp-reducer";
import { FC, useEffect } from "react";
import { UseFormReset } from "react-hook-form";
import { OtpFormValues } from "./verify-otp-form.component";
import { toast } from "react-toastify";

type TimerAndResendOtpProps = {
  dispatch: React.ActionDispatch<[action: OtpAction]>;
  phoneNumber?: string;
  timer: number;
  resetForm: UseFormReset<OtpFormValues>;
};

const TimerAndResendOtp: FC<TimerAndResendOtpProps> = ({
  timer,
  phoneNumber,
  dispatch,
  resetForm,
}) => {
  const { mutate, isPending } = useSendOtpMutation();
  const handleResendOtp = () => {
    if (timer === 0 && phoneNumber) {
      mutate(
        {
          mobile: phoneNumber,
        },
        {
          onSuccess: () => {
            dispatch({
              type: "SET_PHONE_NUMBER",
              payload: phoneNumber,
            });
            resetForm();
          },
          onError: (err) => {
            toast.error(err?.message);
          },
        }
      );
    }
  };

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (timer > 0 && phoneNumber) {
      interval = setInterval(() => {
        dispatch({ type: "SET_TIMER", payload: timer - 1 });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer, phoneNumber]);

  return (
    <div className="text-sm flex justify-end">
      {timer > 0 ? (
        <span className="py-2 font-bold">{formatTime(timer)}</span>
      ) : (
        <Button
          variant="ghost"
          onClick={handleResendOtp}
          type="button"
          className="py-2 text-sm px-0 h-fit hover:!bg-transparent disabled:!bg-transparent text-primary font-bold"
          disabled={timer > 0 || isPending}
        >
          {isPending ? "در حال ارسال..." : "دریافت مجدد کد"}
        </Button>
      )}
    </div>
  );
};

export default TimerAndResendOtp;
